import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import API_BASE from '../../utils/api.js';
import notify from '../../utils/notify';
import '../../component-styles/TagsSettings.css';

function formatCurrency(v) {
  if (v == null || Number.isNaN(Number(v))) return null;
  return Number(v).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
}

export default function TaggedItemsPage() {
  const { tagName } = useParams();
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !tagName) return;
    setLoading(true);
    fetch(`${API_BASE}/api/tags/${encodeURIComponent(userId)}/items?tag=${encodeURIComponent(tagName)}`)
      .then((r) => r.json())
      .then((data) => setItems(Array.isArray(data) ? data : []))
      .catch(() => notify('Failed to load tagged items'))
      .finally(() => setLoading(false));
  }, [userId, tagName]);

  return (
    <div className="tagset-container">
      <div className="tagset-header" style={{ alignItems: 'center', gap: 10 }}>
        <button
          className="tagset-back-btn"
          onClick={() => navigate('/settings/tags')}
        >
          <ArrowLeft size={14} /> Tags
        </button>
        <span className="tagset-chip" style={{ fontSize: '1rem', fontWeight: 600 }}>
          {tagName}
        </span>
      </div>

      {loading ? (
        <span className="tagset-empty">Loading…</span>
      ) : items.length === 0 ? (
        <span className="tagset-empty">No items are tagged "{tagName}".</span>
      ) : (
        <table className="tagged-items-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Number</th>
              <th>Status</th>
              <th>Total</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={`${item.type}-${item.id}`}>
                <td>{item.type}</td>
                <td>
                  {item.path ? (
                    <Link to={item.path}>{item.label}</Link>
                  ) : (
                    item.label
                  )}
                </td>
                <td style={{ textTransform: 'capitalize' }}>
                  {item.status?.replace(/_/g, ' ') || '—'}
                </td>
                <td>{formatCurrency(item.total) ?? '—'}</td>
                <td>{item.date ? new Date(item.date).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
